import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateEdition as UpdateEditionMutation,
    UpdateEditionVariables as UpdateEditionMutationVariables,
    EditionUpdateInput,
} from 'nutshell-graphql-types';

import EDITION_FRAGMENT from '../../graphql/fragments/edition-fragment.graphql';
import UPDATE_EDITION from '../../graphql/mutations/update-edition.graphql';

export function useUpdateEdition(): {
    updateEdition: (arg1: EditionUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateEdition, {loading, error}] = useMutation<
        UpdateEditionMutation,
        UpdateEditionMutationVariables
    >(UPDATE_EDITION);

    return {
        updateEdition: (input: EditionUpdateInput) =>
            updateEdition({
                variables: {edition: input},
                update: (proxy, mutationResults) => {
                    const updatedEdition =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.editionUpdate &&
                        mutationResults.data.editionUpdate.edition;

                    if (!updatedEdition) return;

                    proxy.writeFragment({
                        id: input.editionId,
                        fragment: EDITION_FRAGMENT,
                        fragmentName: 'EditionFragment',
                        data: updatedEdition,
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
